export var stories = [
    {
        id: 0,
        title: "The Road to Wrestlemania",
        stages: [
            {
                id: 0,
                title: "Begins with a Rumble victory"
            },
            {
                id: 1,
                title: "The contract signing"
            },
            {
                id: 2,
                title: "The tag match siding together that ends in betrayal"
            },
            {
                id: 3,
                title: "The sneak attack that goes wrong"
            },
            {
                id: 4,
                title: "The last minute heat grab, beat down or bloodied"
            },
            {
                id: 5,
                title: "The show before the show of shows"
            }
        ]
    },
    {
        id: 1,
        title: "Redemption",
        stages: [
            {
                id: 0,
                title: "The return from injury"
            },
            {
                id: 1,
                title: "The interference that costs the match"
            },
            {
                id: 2,
                title: "The match that ends in a draw"
            },
            {
                id: 3,
                title: "The match that ends in chaos and rage"
            },
            {
                id: 4,
                title: "The match that ends in a bloodied and beaten"
            },
            {
                id: 5,
                title: "The loser goes down the card"
            }
        ]
    },
    {
        id: 3,
        title: "The Betrayal of a Lifetime",
        stages: [
            {
                id: 0,
                title: "The formation of a dominant tag team"
            },
            {
                id: 1,
                title: "The tension and arguments leading up to a big match"
            },
            {
                id: 2,
                title: "The surprise betrayal during the match, causing the team to lose"
            },
            {
                id: 3,
                title: "The aftermath of the betrayal, including interviews and backstage confrontations"
            },
            {
                id: 4,
                title: "The challenger who takes advantage of the team's weakened state"
            },
            {
                id: 5,
                title: "The ultimate showdown between the two former allies"
            }
        ]
    },
    {
        id: 4,
        title: "The Rise of a New Champion",
        stages: [
            {
                id: 0,
                title: "The new wrestler's humble beginnings and struggles"
            },
            {
                id: 1,
                title: "The surprising win over a more established wrestler"
            },
            {
                id: 2,
                title: "The challenges and obstacles the new wrestler faces on their path to the top"
            },
            {
                id: 3,
                title: "The turning point where the new wrestler gains momentum and support from the fans"
            },
            {
                id: 4,
                title: "The championship match where the new wrestler faces the current champion"
            },
            {
                id: 5,
                title: "The epic showdown that ends in a new champion being crowned, against all odds."
            }
        ]
    },
    {
        id: 5,
        title: "The Underdog",
        stages: [
            {
                id: 0,
                title: "The underdog's rise to fame"
            },
            {
                id: 1,
                title: "The underdog's first big win"
            },
            {
                id: 2,
                title: "The underdog's first championship match"
            },
            {
                id: 3,
                title: "The underdog's loss of the championship"
            },
            {
                id: 4,
                title: "The underdog's comeback and redemption"
            },
            {
                id: 5,
                title: "The underdog's ultimate victory and triumph"
            }
        ]
    },
    {
        id: 6,
        title: "The Newcomer",
        stages: [
            {
                id: 0,
                title: "The newcomer's debut match"
            },
            {
                id: 1,
                title: "The newcomer's first win"
            },
            {
                id: 2,
                title: "The newcomer's first championship match"
            },
            {
                id: 3,
                title: "The newcomer's loss of the championship"
            },
            {
                id: 4,
                title: "The newcomer's comeback and redemption"
            },
            {
                id: 5,
                title: "The newcomer's ultimate victory and triumph"
            }
        ]
    },
    {
        id: 7,
        title: "Who is the best?",
        stages: [
            {
                id: 0,
                title: "The first match between the two wrestlers"
            },
            {
                id: 1,
                title: "The second match between the two wrestlers"
            },
            {
                id: 2,
                title: "The third match between the two wrestlers"
            },
            {
                id: 3,
                title: "The fourth match between the two wrestlers"
            },
            {
                id: 4,
                title: "The fifth match between the two wrestlers"
            },
            {
                id: 5,
                title: "The sixth grudge match between the two wrestlers"
            }
        ]
    },
    {
        id: 8,
        title: "The New Champion",
        stages: [
            {
                id: 0,
                title: "The new champion's first title defense"
            },
            {
                id: 1,
                title: "The new champion's second title defense"
            },
            {
                id: 2,
                title: "The new champion's third title defense"
            },
            {
                id: 3,
                title: "The new champion's fourth title defense"
            },
            {
                id: 4,
                title: "The new champion's fifth title defense"
            },
            {
                id: 5,
                title: "The new champion's sixth title defense, can it last?"
            }
        ]
    },
    //
    {
        "id": 9,
        "title": "Finishing the story",
        "stages": [
            {
                "id": 0,
                "title": "The Beginning: Returning with a goal to win the World Championship, which his father never achieved"
            },
            {
                "id": 1,
                "title": "The First Encounter: Challenging the Undisputed Champion in the main event of the biggest yearly event. Losing on the grandest stage of them all"
            },
            {
                "id": 2,
                "title": "Moving onto a feud which will prove my worth to challenge for the championship once more"
            },
            {
                "id": 3,
                "title": "Formidable opponent destroys the challenger in a match that was supposed to be a stepping stone to the championship"
            },
            {
                "id": 4,
                "title": "Training and hard work pay off in the rematch that sets our hero on the path to the championship once more"
            },
            {
                "id": 5,
                "title": "Two opportunities to challenge for the championship, yearly, in a row, a record, which punches your card to the main event of the biggest show of the year!"
            },
            {
                "id": 6,
                "title": "Perseverance and determination pay off as the challenger wins the championship in the main event of the biggest show of the year!"
            },
            {
                "id": 7,
                "title": "A rematch at the hottest show of the summer, the challenger retains and proves hes worthy"
            }
        ]
    }
];
